<template>
  <div class="Melamine">
    <div class="title">Glacial Acrylic Acid</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <el-table-column prop="Description" label="Description">
        </el-table-column>
        <el-table-column prop="Index" label="Index"> </el-table-column>
        <!-- <el-table-column prop="Testmethod" label="Test method">
        </el-table-column> -->
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>200kg/200L plastic drums, 25mt/25CBM ISO tanks or Bulk</p>
    </div>
    <div class="item-huanhang">
      <label>Applications:</label>
      <p>
        Glacial Acrylic Acid Monomer offers significant advantages as an
        acdditive in a wide range of copolymer-based finishes, coatings,
        adhesives, lubricants, saturants, and plastics. Glacial acrylic acid is
        also used in the production of a wide variety of specialty esters, in
        drilling fluids and mineral processing chemicals, detergent builders,
        water treatment chemicalsand in superabsorbent materials.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        {
          Description: "Color, Hazen units, max",
          Index: "10",
          Testmethod: "GOST 14871 and p. 8.2 of this STO or ASTM D 1209-05",
        },
        {
          Description: "Purity, %, min",
          Index: "99.6",
          Testmethod: "p.8.3 of this STO",
        },
        {
          Description: "Water, %, max",
          Index: "0.3",
          Testmethod: "GOST 14870 and p. 8.4 of this STO Or ASTMD 1064-02",
        },
        {
          Description: "Propionic acid, %, max",
          Index: "0.05",
          Testmethod: "MSTM 4290-1 or MSTM 4290-10",
        },
        {
          Description: "Furfurol&acrylic aldehide, %, max",
          Index: "0.02",
          Testmethod: "MSTM 4290-1 or MSTM 4290-10",
        },
        {
          Description: "Inhibitor (p-methoxyphenol) content,ppm,max",
          Index: "220",
          Testmethod: "p.8.7 of this STO or ASTM D 3125-06",
        },
        {
          Description: "Polymer",
          Index: "none",
          Testmethod: "p.8.8 of this STO",
        },
        {
          Description: "Iron,ppm, max",
          Index: "0.3",
          Testmethod: "p.8.9 of this STO",
        },
        {
          Description: "Copper,ppm,max",
          Index: "0.1",
          Testmethod: "p.8.10 of this STO",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
